(function () {
  const root = document.getElementById('pjs-hc')
  if (!root) return

  const select = function (selector, context) {
    return (context || root).querySelector(selector)
  }
  const selectAll = function (selector, context) {
    return Array.prototype.slice.call((context || root).querySelectorAll(selector))
  }

  const secs = selectAll('[data-hc-sec]')
  const items = selectAll('[data-hc-q]')
  const topics = selectAll('[data-hc-topic]')
  const chips = selectAll('[data-hc-chip]')
  const input = select('[data-hc-search]')
  const bar = select('[data-hc-bar]')
  const barActive = select('[data-hc-bar-active]')
  const results = select('[data-hc-results]')
  const empty = select('[data-hc-empty]')
  const isMobile = function () {
    return window.matchMedia('(max-width:900px)').matches
  }

  function syncTop () {
    const header = document.getElementById('shopify-section-header')
    const headerHeight = header ? Math.round(header.getBoundingClientRect().height) : 0
    root.style.setProperty('--hc-top', (headerHeight > 0 ? headerHeight : 96) + 'px')
    const barHeight = bar ? Math.round(bar.getBoundingClientRect().height) : 0
    root.style.setProperty('--hc-bar-h', (barHeight > 0 ? barHeight : 59) + 'px')
    const chipbar = select('.hc-chips')
    root.style.setProperty(
      '--hc-chips-h',
      (chipbar ? Math.round(chipbar.getBoundingClientRect().height) : 0) + 'px'
    )
    const sbw = window.innerWidth - document.documentElement.clientWidth
    root.style.setProperty('--hc-sbw', (sbw > 0 ? sbw : 0) + 'px')
  }
  function topOffset () {
    const styles = getComputedStyle(root)
    const px = function (varName) {
      return parseInt(styles.getPropertyValue(varName), 10) || 0
    }
    return (px('--hc-top') || 96) + px('--hc-bar-h') + px('--hc-chips-h') + 24
  }
  syncTop()
  window.addEventListener('resize', syncTop)

  const scrollHold = window.matchMedia('(prefers-reduced-motion: reduce)')
  function smooth () {
    document.documentElement.classList.toggle('lo-suave', !scrollHold.matches)
  }
  smooth()
  scrollHold.addEventListener('change', smooth)

  const toast = document.createElement('div')
  toast.id = 'pjs-hc-toast'
  toast.setAttribute('role', 'status')
  toast.setAttribute('aria-live', 'polite')
  document.body.appendChild(toast)
  let toastT
  function flash (msg) {
    toast.textContent = msg
    toast.classList.add('is-on')
    clearTimeout(toastT)
    toastT = setTimeout(function () {
      toast.classList.remove('is-on')
    }, 1800)
  }

  function copyText (text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        return legacy(text)
      })
    }
    return legacy(text)
  }
  function legacy (text) {
    return new Promise(function (res, rej) {
      try {
        const textareaEl = document.createElement('textarea')
        textareaEl.value = text
        textareaEl.setAttribute('readonly', '')
        textareaEl.style.cssText = 'position:fixed;top:-1000px;opacity:0'
        document.body.appendChild(textareaEl)
        textareaEl.select()
        textareaEl.setSelectionRange(0, text.length)
        const copied = document.execCommand('copy')
        document.body.removeChild(textareaEl)
        copied ? res() : rej(new Error('copy failed'))
      } catch (e) {
        rej(e)
      }
    })
  }
  function urlFor (id) {
    return location.origin + location.pathname + '#' + id
  }

  function setOpen (item, open) {
    const panelEl = select('.hc-a', item)
    const toggles = selectAll('[data-hc-toggle]', item)
    item.classList.toggle('is-open', open)
    if (panelEl) panelEl.hidden = !open
    toggles.forEach(function (toggleEl) {
      if (toggleEl.hasAttribute('aria-expanded')) {
        toggleEl.setAttribute('aria-expanded', open ? 'true' : 'false')
      }
    })
  }
  items.forEach(function (item) {
    selectAll('[data-hc-toggle]', item).forEach(function (btn) {
      btn.addEventListener('click', function () {
        const open = !item.classList.contains('is-open')
        setOpen(item, open)
        if (open) {
          try {
            history.replaceState(null, '', '#' + item.id)
          } catch (e) {}
        }
      })
    })
    selectAll('[data-hc-copylink]', item).forEach(function (btn) {
      const label = select('[data-hc-copylabel]', btn)
      btn.addEventListener('click', function (e) {
        e.stopPropagation()
        try {
          history.replaceState(null, '', '#' + item.id)
        } catch (err) {}
        copyText(urlFor(item.id))
          .then(function () {
            btn.classList.add('is-copied')
            if (label) label.textContent = 'Copied'
            flash('Link copied to clipboard')
            setTimeout(function () {
              btn.classList.remove('is-copied')
              if (label) label.textContent = 'Copy link'
            }, 1800)
          })
          .catch(function () {
            flash('Link is in your address bar')
          })
      })
    })
    selectAll('[data-hc-rel]', item).forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault()
        openQ(link.getAttribute('data-hc-rel'))
      })
    })
  })

  const calmMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  function glide () {
    return calmMotion.matches ? 'auto' : 'smooth'
  }
  function jump (target) {
    if (!target) return
    window.scrollTo({
      top: target.getBoundingClientRect().top + window.scrollY - topOffset(),
      behavior: glide()
    })
  }
  function openQ (id) {
    const questionEl = document.getElementById(id)
    if (!questionEl) return false
    if (input && input.value) {
      input.value = ''
      runSearch()
    }
    setFilter('all', false)
    if (questionEl.hasAttribute('data-hc-q')) setOpen(questionEl, true)
    else {
      const lead = questionEl.querySelector('[data-hc-q]')
      if (lead) setOpen(lead, true)
    }
    try {
      history.replaceState(null, '', '#' + id)
    } catch (e) {}
    setTimeout(function () {
      jump(questionEl)
    }, 60)
    return true
  }

  let filter = 'all'
  function setFilter (key, doScroll) {
    filter = key
    chips.forEach(function (chip) {
      const isActive = chip.getAttribute('data-hc-chip') === key
      chip.classList.toggle('is-on', isActive)
      chip.setAttribute('aria-pressed', isActive ? 'true' : 'false')
    })
    if (isMobile()) {
      secs.forEach(function (section) {
        section.hidden = !(key === 'all' || section.getAttribute('data-hc-sec') === key)
      })
      /*
         Scrolling to the top left every pill in the same place, the search field,
         and not on the topic chosen: on mobile it looked as if none of them led to
         its section. It jumps to it as on desktop; only All topics, which has no
         single one, goes to the top.
      */
      if (doScroll) {
        const jumpTo = key === 'all' ? null : document.getElementById(key)
        if (jumpTo) jump(jumpTo)
        else window.scrollTo({ top: 0, behavior: glide() })
      }
    } else {
      secs.forEach(function (section) {
        section.hidden = false
      })
      if (key !== 'all') {
        const target = document.getElementById(key)
        if (target && doScroll) jump(target)
      }
    }
  }
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      if (input && input.value) {
        input.value = ''
        runSearch()
      }
      setFilter(chip.getAttribute('data-hc-chip'), true)
    })
  })
  topics.forEach(function (topic) {
    topic.addEventListener('click', function () {
      if (input && input.value) {
        input.value = ''
        runSearch()
      }
      const section = document.getElementById(topic.getAttribute('data-hc-topic'))
      setActive(topic.getAttribute('data-hc-topic'))
      jump(section)
    })
  })
  function setActive (key) {
    topics.forEach(function (topic) {
      const isActive = topic.getAttribute('data-hc-topic') === key
      topic.classList.toggle('is-on', isActive)
      if (isActive) {
        topic.setAttribute('aria-current', 'true')
      } else {
        topic.removeAttribute('aria-current')
      }
    })
    if (!barActive) return
    const sec = select('[data-hc-sec="' + key + '"]')
    const head = sec ? select('h2', sec) : null
    if (head) {
      barActive.textContent = head.textContent.replace(/\s+/g, ' ').trim()
    }
  }

  let raf = null
  function onScroll () {
    if (raf) return
    raf = requestAnimationFrame(function () {
      raf = null
      const line = topOffset() + 40
      let cur = null
      secs.forEach(function (section) {
        if (!section.hidden && section.getBoundingClientRect().top <= line) {
          cur = section.getAttribute('data-hc-sec')
        }
      })
      if (cur) setActive(cur)
      if (bar) bar.classList.toggle('is-on', window.scrollY > 420 && !isMobile())
    })
  }
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()

  function esc (text) {
    return text.replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]
    })
  }
  function hcRoot (word) {
    if (word.length >= 4 && word.charAt(word.length - 1) === 's' && word.slice(-2) !== 'ss') {
      return word.slice(0, -1)
    }
    return word
  }
  function queryTerms (raw) {
    if (!raw) return []
    const words = raw
      .toLowerCase()
      .split(/\s+/)
      .filter(function (word) {
        return word.length > 1
      })
      .map(hcRoot)
    return words.length ? words : [hcRoot(raw.toLowerCase())]
  }
  function sectionText (sec) {
    if (!sec.__hay) {
      const texts = []
      const mainEl = select('.hc-sec-main', sec)
      if (mainEl) texts.push(mainEl.textContent)
      const extraEl = select('.hc-sec-n', sec)
      if (extraEl) texts.push(extraEl.textContent)
      selectAll('[role="tab"]', sec).forEach(function (tabEl) {
        texts.push(tabEl.textContent)
      })
      sec.__hay = texts.join(' ').toLowerCase().replace(/\s+/g, ' ')
    }
    return sec.__hay
  }
  function sectionMatches (sec, terms) {
    if (!terms.length) return false
    const hay = sectionText(sec)
    return terms.every(function (term) {
      return hay.indexOf(term) > -1
    })
  }

  function paint (btn, terms) {
    const question = btn.getAttribute('data-q') || ''
    if (!terms.length) {
      btn.textContent = question
      return
    }
    const low = question.toLowerCase()
    const spans = []
    terms.forEach(function (term) {
      for (let pos = low.indexOf(term); pos > -1; pos = low.indexOf(term, pos + term.length)) {
        spans.push([pos, pos + term.length])
      }
    })
    if (!spans.length) {
      btn.textContent = question
      return
    }
    spans.sort(function (a, b) {
      return a[0] - b[0]
    })
    let out = ''
    let from = 0
    spans.forEach(function (span) {
      if (span[1] <= from) return
      const start = span[0] > from ? span[0] : from
      out +=
        esc(question.slice(from, start)) +
        '<mark>' +
        esc(question.slice(start, span[1])) +
        '</mark>'
      from = span[1]
    })
    out += esc(question.slice(from))
    btn.innerHTML = out
  }
  function runSearch () {
    const raw = (input ? input.value : '').trim()
    const terms = queryTerms(raw)
    const clear = select('[data-hc-clear]')
    if (clear) clear.hidden = !raw
    const scored = []
    let best = 0
    items.forEach(function (item) {
      const btn = select('[data-hc-toggle]', item)
      const hay = (
        btn.getAttribute('data-q') +
        ' ' +
        (select('[data-hc-answer]', item) || { textContent: '' }).textContent
      ).toLowerCase()
      let score = 0
      terms.forEach(function (term) {
        if (hay.indexOf(term) > -1) score++
      })
      if (score > best) best = score
      scored.push({ item, btn, score })
    })
    const found = []
    scored.forEach(function (row) {
      const hit = !raw || (best > 0 && row.score === best)
      row.item.hidden = !hit
      paint(row.btn, hit ? terms : [])
      if (raw) setOpen(row.item, false)
      if (hit && raw) found.push(row.item)
    })
    if (found.length && found.length <= 3) {
      found.forEach(function (entry) {
        setOpen(entry, true)
      })
    }
    let matchingSections = 0
    if (raw) {
      secs.forEach(function (section) {
        const any = selectAll('[data-hc-q]', section).some(function (entry) {
          return !entry.hidden
        })
        const ownMatch = sectionMatches(section, terms)
        if (ownMatch && !any) matchingSections++
        section.hidden = !(any || ownMatch)
      })
    } else {
      setFilter(filter, false)
      items.forEach(function (entry) {
        entry.hidden = false
      })
      secs.forEach(function (section) {
        section.hidden = false
      })
    }
    if (results) {
      const wasOpen = results.hidden
      results.hidden = !raw
      if (raw && wasOpen) showResults()
      if (raw) {
        const total = found.length + matchingSections
        const countEl = select('[data-hc-count]', results)
        if (countEl) countEl.textContent = total
        const unitEl = select('[data-hc-unit]', results)
        if (unitEl) unitEl.textContent = total === 1 ? 'result' : 'results'
        const qout = select('[data-hc-qtext]', results)
        if (qout) qout.textContent = raw
      }
    }
    if (empty) {
      empty.hidden = !(raw && !found.length && !matchingSections)
      const queryEl = select('[data-hc-q2]')
      if (queryEl) queryEl.textContent = raw
    }
  }
  function showResults () {
    if (!results || results.hidden) return
    let jumpTo = results.getBoundingClientRect().top + window.pageYOffset - topOffset()
    if (jumpTo < 0) jumpTo = 0
    if (Math.abs(jumpTo - window.pageYOffset) < 8) return
    window.scrollTo(0, jumpTo)
  }

  const box = select('.hc-search')
  if (input) {
    input.addEventListener('input', function () {
      const hay = input.value.trim().length > 0
      if (box) box.classList.toggle('has-text', hay)
      const clearBtn = select('[data-hc-clear]')
      if (clearBtn) clearBtn.hidden = !hay
      if (!hay) runSearch()
    })
  }
  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault()
        runSearch()
        showResults()
      }
    })
  }
  const clearBtn = select('[data-hc-clear]')
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = ''
      if (box) box.classList.remove('has-text')
      runSearch()
      input.focus()
    })
  }
  const cl2 = select('[data-hc-clear2]')
  if (cl2) {
    cl2.addEventListener('click', function () {
      input.value = ''
      if (box) box.classList.remove('has-text')
      runSearch()
      focusSearch()
    })
  }
  function focusSearch () {
    window.scrollTo({ top: 0, behavior: glide() })
    setTimeout(function () {
      if (input) input.focus()
    }, 260)
  }
  selectAll('[data-hc-focus]').forEach(function (focusBtn) {
    focusBtn.addEventListener('click', focusSearch)
  })
  document.querySelectorAll('[data-hc-inline]').forEach(function (btn) {
    const body = btn.parentNode.querySelector('[data-hc-inline-body]')
    btn.addEventListener('click', function () {
      const open = btn.getAttribute('aria-expanded') === 'true'
      if (open) {
        btn.setAttribute('aria-expanded', 'false')
        body.hidden = true
        return
      }
      if (!body.innerHTML) {
        const src = document.getElementById('a-' + btn.getAttribute('data-hc-inline'))
        if (!src) {
          return
        }
        const clone = src.cloneNode(true)
        const rel = clone.querySelector('.hc-rel')
        if (rel) {
          rel.parentNode.removeChild(rel)
        }
        body.innerHTML = clone.innerHTML
      }
      btn.setAttribute('aria-expanded', 'true')
      body.hidden = false
    })
  })

  document.addEventListener('keydown', function (e) {
    const activeEl = document.activeElement || {}
    if (
      e.key === '/' &&
      activeEl !== input &&
      !/input|textarea|select/i.test(activeEl.tagName || '')
    ) {
      e.preventDefault()
      focusSearch()
    } else if (e.key === 'Escape' && input && input.value) {
      input.value = ''
      if (box) box.classList.remove('has-text')
      runSearch()
    }
  })

  function findQ (needle) {
    const lower = needle.toLowerCase()
    for (let i = 0; i < items.length; i++) {
      const question = (
        select('[data-hc-toggle]', items[i]).getAttribute('data-q') || ''
      ).toLowerCase()
      if (question.indexOf(lower) > -1) return items[i]
    }
    return null
  }

  function fromHash () {
    let hash = (location.hash || '').replace('#', '')
    if (!hash) return
    if (hash.indexOf('tab-') === 0) hash = hash.slice(4)
    if (hash.indexOf('cat-') === 0) hash = hash.slice(4)
    openQ(hash)
  }
  window.addEventListener('load', function () {
    syncTop()
    fromHash()
  })
  window.addEventListener('hashchange', fromHash)
  window.addEventListener('resize', function () {
    if (input && input.value.trim()) runSearch()
    else setFilter(filter, false)
  })

  try {
    const seen = {}
    const list = []
    items.forEach(function (item) {
      const question = select('[data-hc-toggle]', item).getAttribute('data-q') || ''
      const answerEl = select('[data-hc-answer]', item)
      const txt = answerEl ? answerEl.textContent.replace(/\s+/g, ' ').trim() : ''
      if (!question || !txt || seen[question]) return
      seen[question] = 1
      list.push({
        '@type': 'Question',
        name: question,
        url: urlFor(item.id),
        acceptedAnswer: { '@type': 'Answer', text: txt }
      })
    })
    if (list.length) {
      const scriptEl = document.createElement('script')
      scriptEl.type = 'application/ld+json'
      scriptEl.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: list
      })
      document.head.appendChild(scriptEl)
    }
  } catch (e) {}
})()
